import React, { useState } from "react";
import PropTypes from "prop-types";
import ButtonGroup from "@mui/material/ButtonGroup";
import SFButton from "../button";
import { SFStack } from "../grid";

const SFButtonGroup = ({
  orientation = "horizontal",
  size = "medium",
  buttons,
  iconSelectedOnly = false,
  indicateSelected = false,
  className,
  variant = "outlined",
  color = "primary",
}) => {
  let selectedBtnIndex = buttons.findIndex((x) => x.selected);
  const [selected, setSelected] = useState(
    selectedBtnIndex === -1 ? 0 : selectedBtnIndex
  );
  return (
    <ButtonGroup
      color={color}
      variant={variant}
      size={size}
      orientation={orientation}
      className={className}
    >
      {buttons.map((btn, index) => (
        <SFButton
          key={index}
          size={size}
          {...(index === selected && { className: "selected" })}
          {...(indicateSelected && {
            variant: index === selected ? "primary" : "secondary",
          })}
          disabled={btn.disabled}
          onClick={() => {
            setSelected(index);
            btn.onClick();
          }}
        >
          <SFStack direction="row" spacing={1} alignItems="center">
            {((index === selected && iconSelectedOnly) || !iconSelectedOnly) &&
              btn?.icon}
            <div>{btn.label}</div>
          </SFStack>
        </SFButton>
      ))}
    </ButtonGroup>
  );
};

SFButtonGroup.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      selected: PropTypes.bool,
      disabled: PropTypes.bool,
      icon: PropTypes.node,
    }).isRequired
  ),
  iconSelectedOnly: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["outlined", "switch"]),
  color: PropTypes.oneOf(["primary", "secondary"]),
  indicateSelected: PropTypes.bool,
};

export default SFButtonGroup;
